<!-- Chat Container -->
<div class="chat-container">
  <!-- Chat Header -->
  <div class="chat-header">
    <div class="chat-header-info">
      <h2>Chat com a Empresa</h2>
    </div>
    <div class="chat-actions">
      <button class="btn btn-icon" title="Atualizar" (click)="refreshMessages()" [disabled]="loading">
        <i class="fas fa-sync-alt" [class.fa-spin]="loading"></i>
      </button>
    </div>
  </div>

  <!-- Chat Content -->
  <div class="chat-content">
    <!-- Chat Main -->
    <div class="chat-main">
      <!-- Mensagem de erro -->
      <div *ngIf="errorMessage" class="alert alert-danger alert-dismissible fade show" role="alert">
        {{ errorMessage }}
        <button type="button" class="btn-close" (click)="errorMessage = ''"></button>
      </div>

      <!-- Loading spinner -->
      <div *ngIf="loading" class="text-center my-4">
        <div class="spinner-border text-primary" role="status">
          <span class="visually-hidden">Carregando...</span>
        </div>
      </div>

      <!-- Chat Messages -->
      <div class="chat-messages" #messagesContainer (scroll)="onScroll($event)">
        <!-- Empty State -->
        <div class="empty-state" *ngIf="!loading && messages.length === 0">
          <i class="fas fa-comments"></i>
          <h3>Nenhuma mensagem ainda</h3>
          <p>Inicie uma conversa!</p>
        </div>

        <!-- Message Groups -->
        <div class="message-group" *ngFor="let message of messages">
          <div class="message-date">{{ formatMessageDate(message.timestamp) }}</div>
          
          <!-- Message -->
          <div class="message" [class.received]="message.senderId !== user.Id" [class.sent]="message.senderId === user.Id">
            <div class="message-avatar" *ngIf="message.senderId !== user.Id">
              <img [src]="message.senderAvatar" [alt]="message.senderName">
            </div>
            <div class="message-content">
              <div class="message-header">
                <span class="sender-name" *ngIf="message.senderId !== user.Id">{{ message.senderName }}</span>
                <span class="message-time">{{ formatMessageTime(message.timestamp) }}</span>
              </div>
              <div class="message-text">
                {{ message.content }}
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- Chat Input -->
      <div class="chat-input">
        <form [formGroup]="messageForm" (ngSubmit)="sendMessage()">
          <div class="input-actions">
            <!--<button type="button" class="btn btn-icon" title="Anexar arquivo">
              <i class="fas fa-paperclip"></i>
            </button>-->
          </div>
          <div class="message-input">
            <textarea 
              formControlName="message"
              class="form-control" 
              placeholder="Digite sua mensagem..." 
              rows="1"
              [ngClass]="{'is-invalid': messageForm.get('message')?.invalid && messageForm.get('message')?.touched}"
              (keydown.enter)="sendMessage()">
            </textarea>
          </div>
          <button type="submit" class="btn btn-primary send-button" [disabled]="messageForm.invalid || loading">
            <i class="fas fa-paper-plane"></i>
          </button>
        </form>
        <div class="invalid-feedback" *ngIf="messageForm.get('message')?.invalid && messageForm.get('message')?.touched">
          A mensagem não pode estar vazia
        </div>
      </div>
    </div>
  </div>
</div> 